var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8714 22.8762H1.12855C0.828893 22.8762 0.585693 22.6851 0.585693 22.4497V17.9913C0.585693 15.843 3.07686 13.3654 5.01758 12.0001C3.07741 10.6348 0.585693 8.15722 0.585693 6.00887V1.55054C0.585693 1.3151 0.828893 1.12402 1.12855 1.12402H16.8714C17.1711 1.12402 17.4143 1.3151 17.4143 1.55054V6.00887C17.4143 8.15722 14.9231 10.6348 12.9824 12.0001C14.9225 13.3654 17.4143 15.843 17.4143 17.9913V22.4497C17.4143 22.6851 17.1711 22.8762 16.8714 22.8762ZM1.67141 22.0231H16.3285V17.9913C16.3285 16.1872 13.9981 13.7288 11.8049 12.3315C11.6779 12.2505 11.6041 12.1285 11.6041 12.0001C11.6041 11.8717 11.6779 11.7497 11.8049 11.6687C13.9981 10.2714 16.3285 7.81302 16.3285 6.00887V1.97705H1.67141V6.00887C1.67141 7.81302 4.00189 10.2714 6.19504 11.6687C6.32206 11.7497 6.39589 11.8717 6.39589 12.0001C6.39589 12.1285 6.32206 12.2505 6.19504 12.3315C4.00189 13.7288 1.67141 16.1872 1.67141 17.9913V22.0231Z",
    fill: "#0D45DF",
    stroke: "#0D45DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassActive);
export default __webpack_public_path__ + "static/media/hourglass_active.4017fe794445e75b8e9bbc75014fbfac.svg";
export { ForwardRef as ReactComponent };